import Box from '@mui/material/Box';
import { contentGutter } from '../app-shell/constants';

import type { ReactNode, Ref } from 'react';
import type { SystemStyleObject } from '@mui/system';
import type { Theme } from '@mui/material/styles';

/*
 * The page stands off the bar above it and the rail beside it. The right side keeps the narrower
 * inset: the shell already centres the content there, so the room is on that edge either way.
 */
const pageContainerSx = {
  pt: { xs: 3, md: 4 },
  pb: { xs: 3, md: 4 },
  pl: { xs: 2, md: 4 },
  pr: contentGutter,
  '&:focus-visible': { outline: '0.125rem solid', outlineColor: 'primary.main', outlineOffset: '0.125rem' },
};

type PageContainerProps = {
  children: ReactNode;
  sx?: SystemStyleObject<Theme>;
  ref?: Ref<HTMLElement>;
};

function PageContainer({ children, sx, ref }: PageContainerProps) {
  return (
    <Box component="section" id="main" tabIndex={-1} ref={ref} sx={{ ...pageContainerSx, ...sx }}>
      {children}
    </Box>
  );
}

export { PageContainer, pageContainerSx };
export type { PageContainerProps };
